// extracted by mini-css-extract-plugin
module.exports = {"item":"CommentItem_item__3hWvO"};